import { isLocale } from '@repo/i18n';
import { useTranslation } from '@repo/i18n/react';
export const LanguageSelector = () => {
  const { locale, setLocale, t } = useTranslation();
  return (
    <select
      aria-label={t('language')}
      className="rounded-md border bg-background px-2 py-1 text-foreground text-sm"
      onChange={(event) => {
        if (isLocale(event.target.value)) {
          setLocale(event.target.value);
        }
      }}
      value={locale}
    >
      <option lang="en" value="en">
        {t('ui.english')}
      </option>
      <option lang="fa" value="fa">
        فارسی
      </option>
    </select>
  );
};
